import { fetchRequest } from "@providers/conect";

const getAllUsuariosApi = async () => {
  try {
    const url = `usuarios/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewUsuariosApi = async (data) => {
  try {
    const url = `usuarios/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const createUsuarioApi = async (data) => {
  try {
    const url = `usuarios/create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateUsuarioApi = async (id, data) => {
  try {
    const url = `usuarios/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUsuarioApi = async (id) => {
  try {
    const url = `usuarios/delete/${id}`;
    const response = await fetchRequest(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const loginUsuarioApi = async (data) => {
  try {
    const url = `usuarios/login`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  getAllUsuariosApi,
  viewUsuariosApi,
  createUsuarioApi,
  updateUsuarioApi,
  deleteUsuarioApi,
  loginUsuarioApi
};